import installer from './defaults'

export * from '@map-sdk/components'
// export * from '@map-sdk/constants'
// export * from '@map-sdk/directives'
export * from '@map-sdk/hooks'
export * from '@map-sdk/sdk'
export * from './make-installer'

export const install = installer.install
export const version = installer.version
export default installer

export { default as dayjs } from 'dayjs'
